export default {
  FACET_TOGGLE_LABEL_CLASS: 'Not vehicle specific.',
};
